import React from "react";

const G = "#0077B5";

const DASH_STEPS = [
  { title: "Your follower count", body: "Enter your real follower count here for accurate reach estimates." },
  { title: "Post controls", body: "Edit, rewrite, swap the article, or approve each post. Posts auto-approve after 5 days." },
  { title: "Posting mode", body: "Review mode lets you approve posts first. Autopilot sends them automatically." },
  { title: "My Posts", body: "Manage all your posts — upcoming and past — in one place." },
  { title: "Settings", body: "Update your topics, voice, RSS feeds and more in Settings." },
];

const SETTINGS_STEPS = [
  { tab: "profile",       label: "Profile",       body: "Your voice, topics and LinkedIn connection." },
  { tab: "billing",       label: "Billing",       body: "Manage your plan and see your invoices." },
  { tab: "notifications", label: "Notifications", body: "Control when and how we email you." },
  { tab: "scheduling",    label: "Scheduling",    body: "Set your edit window and posting times." },
  { tab: "compliance",    label: "Compliance",    body: "Rules to keep your posts professional and on-brand." },
  { tab: "analytics",     label: "Analytics",     body: "Track your follower growth and estimated reach." },
  { tab: "rss",           label: "RSS Feeds",     body: "Add your favourite websites as content sources." },
  { tab: "filters",       label: "Filters",       body: "Block topics or keywords you never want posted." },
  { tab: "account",       label: "Account",       body: "Manage your login and cancel anytime." },
];

export function DashTour({ step, setStep }) {
  if (step < 0 || step > 4) return null;
  // Tour is desktop-only — skip on mobile
  if (typeof window !== 'undefined' && window.innerWidth < 768) return null;
  const s = DASH_STEPS[step];
  const isLast = step === 4;
  const isFirst = step === 0;
  return (
    <>
      <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1000, pointerEvents: "none" }} />
      <div style={{ position: "fixed", bottom: step <= 2 ? 80 : 70, left: "50%", transform: "translateX(-50%)", zIndex: 1001, background: "#fff", borderRadius: 14, boxShadow: "0 8px 32px rgba(0,0,0,0.22)", padding: "22px 24px", maxWidth: 360, width: "90vw", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: G }}>{s.title}</div>
          <div style={{ fontSize: 12, color: "#aaa" }}>{step + 1} / 5</div>
        </div>
        <div style={{ fontSize: 14, color: "#444", lineHeight: 1.6, marginBottom: 16 }}>{s.body}</div>
        <div style={{ display: "flex", gap: 8, justifyContent: "space-between", alignItems: "center" }}>
          <button onClick={() => { localStorage.setItem("nectar_tour_completed", "1"); setStep(-1); }}
            style={{ background: "transparent", color: "#999", border: "none", fontSize: 12, cursor: "pointer", padding: 0 }}>Skip tour</button>
          <div style={{ display: "flex", gap: 8 }}>
            {!isFirst && <button onClick={() => setStep(s2 => s2 - 1)} style={{ background: "transparent", color: "#666", border: "1px solid #e0dfdc", borderRadius: 7, padding: "7px 14px", fontSize: 13, cursor: "pointer" }}>← Back</button>}
            <button onClick={() => { if (isLast) { localStorage.setItem("nectar_tour_completed", "1"); setStep(-1); } else setStep(s2 => s2 + 1); }}
              style={{ background: G, color: "#fff", border: "none", borderRadius: 7, padding: "7px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              {isLast ? "Done ✓" : "Next →"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export function SettingsTour({ step, setStep, setSettingsTab }) {
  if (step < 0 || step > 8) return null;
  // Tour is desktop-only — skip on mobile
  if (typeof window !== 'undefined' && window.innerWidth < 768) return null;
  const s = SETTINGS_STEPS[step];
  const isLast = step === 8;
  const isFirst = step === 0;
  return (
    <>
      <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1000, pointerEvents: "none" }} />
      <div style={{ position: "fixed", bottom: 70, left: "50%", transform: "translateX(-50%)", zIndex: 1001, background: "#fff", borderRadius: 14, boxShadow: "0 8px 32px rgba(0,0,0,0.22)", padding: "22px 24px", maxWidth: 360, width: "90vw", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: G }}>{s.label}</div>
          <div style={{ fontSize: 12, color: "#aaa" }}>{step + 1} / 9</div>
        </div>
        <div style={{ fontSize: 14, color: "#444", lineHeight: 1.6, marginBottom: 16 }}>{s.body}</div>
        <div style={{ display: "flex", gap: 8, justifyContent: "space-between", alignItems: "center" }}>
          <button onClick={() => { localStorage.setItem("nectar_settings_tour_completed", "1"); setStep(-1); }}
            style={{ background: "transparent", color: "#999", border: "none", fontSize: 12, cursor: "pointer", padding: 0 }}>Skip tour</button>
          <div style={{ display: "flex", gap: 8 }}>
            {!isFirst && <button onClick={() => { const prev = step - 1; setStep(prev); setSettingsTab(SETTINGS_STEPS[prev].tab); }} style={{ background: "transparent", color: "#666", border: "1px solid #e0dfdc", borderRadius: 7, padding: "7px 14px", fontSize: 13, cursor: "pointer" }}>← Back</button>}
            <button onClick={() => { if (isLast) { localStorage.setItem("nectar_settings_tour_completed", "1"); setStep(-1); } else { const next = step + 1; setStep(next); setSettingsTab(SETTINGS_STEPS[next].tab); } }}
              style={{ background: G, color: "#fff", border: "none", borderRadius: 7, padding: "7px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              {isLast ? "Done ✓" : "Next →"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
